import { Input } from "@headlessui/react";
import { IInputComponentProps } from "./types";
import React from "react";

const InputComponent = React.forwardRef<HTMLInputElement | null, IInputComponentProps>(
  (
    {
      name,
      onChange,
      onBlur,
      value,
      readOnly,
      disabled,
      className,
      type,
      placeholder,
      error = false,
      onKeyDown,
      maxLength,
      onKeyUp,
    },
    ref,
  ) => {
    return (
      <Input
        ref={ref}
        className={`w-full border dark:border-blueBorderDark rounded-md h-10 p-2 disabled:bg-grey dark:disabled:bg-gray-700 ${error ? "border-red" : ""} ${type === "number" ? "remove-arrow" : ""} ${className ?? ""}`}
        name={name ?? ""}
        type={type ?? "text"}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        readOnly={readOnly ?? false}
        disabled={disabled ?? false}
        placeholder={placeholder ?? ""}
        onKeyDown={onKeyDown}
        onKeyUp={onKeyUp}
        maxLength={maxLength}
      />
    );
  },
);

InputComponent.displayName = "Input";

export default InputComponent;
